export default __webpack_public_path__ + "static/media/limits.b6cc69db.png";